import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';
import { Roles } from 'roles';

import moment from 'moment';

import { BaseSchema } from '../baseSchema';

import { Flights } from '../flights/flights';

import { HiddenField, SelectField } from 'uniforms-bootstrap3';
import DatePickerField from '../../components/fields/datePickerField';

Meteor.users.attachRoles('users');

Meteor.users.label = "L'utilisateur";

export default Meteor.users;

export const UserListSchema = new SimpleSchema([{
	"username": {
		type: String,
		label: "Login"
	},
	"profile": {
		type: Object,
		uniforms: {
			label: null
		}
	},
	"profile.firstName": {
		type: String,
		label: "Prénom"
	},
	"profile.lastName": {
		type: String,
		label: "Nom"
	}
}, BaseSchema]);


export const UserSchema = new SimpleSchema([{
	"username": {
		type: String,
		label: "Login"
	},
	"profile": {
		type: Object,
		uniforms: {
			label: null
		}
	},
	"profile.firstName": {
		type: String,
		label: "Prénom"
	},
	"profile.lastName": {
		type: String,
		label: "Nom"
	},
	"profile.email": {
		type: String,
		regEx: SimpleSchema.RegEx.Email,
		label: "E-mail",
		uniforms: {
			type: "email"
		}
	},
	"profile.certificat": {
		type: String,
		label: "Certificat",
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}
	},
	"profile.licence": {
		type: String,
		label: "Licence",
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}
	},
	"profile.weight": {
		type: Number,
		label: "Poids (en kg)",
		defaultValue: 0
	},
	"profile.freeFlights": {
		type: String,
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}

	},
	"profile.billType": {
		type: String,
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}

	},
	"profile.accessToCalendar": {
		type: String,
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}

	},
	"profile.type": {
		type: String,
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}

	},
	"profile.street": {
		type: String,
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}

	},
	"profile.city": {
		type: String,
		hide: true,
		optional: true,
		uniforms: {
			component: HiddenField
		}

	},
	"profile.phone": {
		type: String,
		label: "Telephone",
		optional: true
	},
	"profile.availabilities": {
		type: [Object],
		optional: true,
		blackbox: true,
		hide: true,
		uniforms: {
			component: HiddenField
		}
	},
	"roles": {
		type: [String],
		label: "Roles",
		allowedValues: ["organizer", "pilot", "partner", "god"],
		defaultValue: [],
		uniforms: {
			checkboxes: true,
			transform: (option) => {
				switch (option) {
					case "organizer":
						return "Administrateur";
					case "pilot":
						return "Pilote";
					case "partner":
						return "Partenaire";
					case "god":
						return "Super-Administrateur";
					default:
						return "N/C";
				}
			},
		}
	},
}, BaseSchema]);

Meteor.users.attachSchema(new SimpleSchema([{
	"services": {
		type: Object,
		blackbox: true,
		optional: true,
	},
}, UserSchema]));

Meteor.users.helpers({
	type: function() {
		let type = "";

		console.log('this.profile.roles', this.profile.roles);

		for (let role of this.profile.roles) {
			if (type.length)
				type += " / ";

			switch (role) {
				case 'organizer':
					type += 'Administrateur';
					break ;
				case 'pilot':
					type += 'Pilote';
					break ;
				case 'partner':
					type += 'Partenaire';
					break ;
				case 'god':
					type += 'Super-Administrateur';
					break ;
				default:
					return 'N/C';
			}
		}

		return type;
	},
	displayName: function() {
		return this.profile.firstName + ' ' + this.profile.lastName;
	},
	flightScheduledAt: function (date, period) {
		return Flights.findOne({
			pilotId: this._id,
			date: moment(date).startOf('day').toDate(),
			period
		});
	}
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/users/users.js
 **/